import { render, staticRenderFns } from "./TopReferrals.vue?vue&type=template&id=2c2f02b0&"
import script from "./TopReferrals.vue?vue&type=script&lang=js&"
export * from "./TopReferrals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports